import React from 'react';
import { motion } from 'framer-motion';
import { ListTodo } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAssignedTasksCount } from '@/hooks/tasks/use-assigned-tasks-count';
import { useLocalStorageState } from '@/hooks/ai-agents/useLocalStorageState';
import { cn } from '@/lib/utils';

const TasksButton = () => {
  const navigate = useNavigate();
  const { data: assignedCount = 0 } = useAssignedTasksCount();
  const { isModalOpen, closeModal } = useLocalStorageState();
  
  const handleClick = () => {
    // Close chat modal if it's open (same pattern as other navbar buttons)
    if (isModalOpen) {
      closeModal();
    }
    navigate('/task-manager');
  };
  
  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="relative"
    >
      <button
        onClick={handleClick}
        className={`
          h-9 w-9 rounded-lg group p-0
          flex items-center justify-center 
          bg-gradient-to-br from-blue-500 to-purple-600
          hover:from-blue-600 hover:to-purple-700
          transition-all duration-200
          shadow-md hover:shadow-lg
        `}
        aria-label="Tasks"
      >
        <motion.div
          whileHover={{ scale: 1.1, rotate: 5 }}
          transition={{ duration: 0.3 }}
        >
          <ListTodo size={18} className="text-white" />
        </motion.div>
      </button>
      
      {/* Task count badge - positioned relative to the motion.div container */}
      {assignedCount > 0 && (
        <span className={cn(
          "absolute -top-1 -right-1 min-w-[18px] h-[18px]",
          "flex items-center justify-center",
          "text-[10px] font-semibold",
          "bg-gradient-to-r from-red-500 to-red-600",
          "text-white rounded-full shadow-sm",
          "border border-white/40",
          "z-10"
        )}>
          {assignedCount > 99 ? '99+' : assignedCount}
        </span>
      )}
    </motion.div>
  );
};

export default TasksButton; 